{
  "common": {
    "loading": "Loading...",
    "redirecting": "Redirecting to sign in...",
    "completingSignIn": "Completing sign-in...",
    "authError": "Authentication Error",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "create": "Create",
    "update": "Update",
    "edit": "Edit",
    "search": "Search",
    "confirm": "Confirm",
    "saving": "Saving...",
    "deleting": "Deleting...",
    "retry": "Retry",
    "noResults": "No results found.",
    "signOut": "Sign out",
    "close": "Close",
    "you": "You",
    "sending": "Sending...",
    "yes": "Yes",
    "no": "No"
  },
  "errorBoundary": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred. You can try again or return to the dashboard.",
    "reload": "Reload",
    "backToDashboard": "Back to dashboard"
  },
  "remarks": {
    "title": "Remarks",
    "menuLabel": "Remarks ({{count}})",
    "empty": "No remarks yet.",
    "addPlaceholder": "Add a private note for your team…",
    "addAction": "Add remark",
    "editAction": "Edit remark",
    "deleteAction": "Delete remark",
    "deleteConfirm": "Delete this remark? This cannot be undone.",
    "unknownCreator": "Unknown",
    "tooltipOpen": "View remarks",
    "select": "Select",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "selectedCount": "{{count}} selected",
    "bulkDeleteTitle": "Delete remarks",
    "bulkDeleteConfirm_one": "Delete {{count}} remark? This cannot be undone.",
    "bulkDeleteConfirm_other": "Delete {{count}} remarks? This cannot be undone.",
    "bulkDeleteConfirm": "Delete {{count}} remarks? This cannot be undone.",
    "errors": {
      "bodyRequired": "Remark cannot be empty.",
      "bodyTooLong": "Remark is too long (max 4000 characters)."
    }
  },
  "nav": {
    "chat": "Chat",
    "contacts": "Contacts",
    "members": "User Management",
    "settings": "Settings",
    "aiFaq": "AI FAQ",
    "templates": "Templates",
    "whatsappTemplates": "WhatsApp Templates",
    "quickReplyTemplates": "Quick Reply Templates",
    "autoReply": "Auto Reply",
    "connectEasyCart": "Connect EasyCart",
    "connectWhatsApp": "Connect New WhatsApp",
    "integrations": "Integrations",
    "developer": "Developer platform",
    "contactTags": "Contact tags"
  },
  "onboarding": {
    "welcomeTitle": "Welcome to LetChat!",
    "welcomeDescription": "You don't have any WhatsApp Profiles yet. Contact your administrator to get a creation quota, then connect your WhatsApp Business Account."
  },
  "contacts": {
    "title": "Contacts",
    "addContact": "Add Contact",
    "searchPlaceholder": "Search contacts...",
    "name": "Name",
    "phone": "Phone",
    "whatsappId": "WhatsApp ID",
    "messages": "Messages",
    "created": "Created",
    "actions": "Actions",
    "openChat": "Open chat",
    "newContact": "New Contact",
    "editContact": "Edit Contact",
    "deleteContact": "Delete Contact",
    "deleteConfirm": "Are you sure you want to delete <strong>{{name}}</strong>? This action cannot be undone. All messages associated with this contact will also be removed.",
    "contactCreated": "Contact created.",
    "contactUpdated": "Contact updated.",
    "contactDeleted": "Contact deleted.",
    "operationFailed": "Operation failed. Please try again.",
    "deleteContactFailed": "Failed to delete contact.",
    "phoneHelp": "Phone number with country code",
    "waIdHelp": "WhatsApp ID without + prefix",
    "assignedTo": "Assigned To",
    "assignTo": "Assign To",
    "assignContact": "Assign Contact",
    "assignSuccess": "Contact assignment updated.",
    "searchMembers": "Search members...",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "bulkAssign": "Assign",
    "bulkAssignSuccess": "{{count}} contacts assigned.",
    "bulkDelete": "Delete Selected",
    "bulkDeleteConfirm": "Are you sure you want to delete {{count}} contacts? This action cannot be undone.",
    "bulkDeleteSuccess": "{{count}} contacts deleted.",
    "import": "Import",
    "importContacts": "Import Contacts",
    "downloadTemplate": "Download Template",
    "importDragDrop": "Drag & drop a file here, or click to browse",
    "importFormats": "Supported formats: XLSX, CSV (max 10MB)",
    "importStart": "Start Import",
    "importInProgress": "Importing...",
    "importProcessing": "Processing import...",
    "importResult": "Created {{created}}, updated {{updated}}, skipped {{skipped}}.",
    "importRowError": "Row {{row}}: {{error}}",
    "hidePhoneToggle": "Hide phone from agents",
    "hidePhoneToggleHelp": "When on, members with the Agent or Read-Only role cannot see contact phone numbers in the list, edit dialog, or search.",
    "searchPlaceholderNameOnly": "Search by name..."
  },
  "chat": {
    "selectContact": "Select a contact to start chatting",
    "selectContactHint": "Choose from your contacts on the left",
    "unknownContact": "Unknown Contact",
    "unknownBadge": "Unknown",
    "createContact": "Create Contact",
    "createContactTitle": "Create Contact",
    "filterAll": "All",
    "filterUnknown": "Unknown",
    "noUnknownContacts": "No unknown contacts.",
    "noMessages": "No messages yet. Send a message to start the conversation.",
    "noContacts": "No contacts found.",
    "typeMessage": "Type a message...",
    "searchContacts": "Search contacts...",
    "sendTemplate": "Send Template",
    "templatePickerTitle": "Message Templates",
    "templatePickerDesc": "Select an approved template to start a conversation",
    "noTemplates": "No approved templates available. Create templates in the Meta Business Suite.",
    "templateSent": "Template message sent.",
    "loadingTemplates": "Loading templates...",
    "windowClosed": "The 24-hour conversation window has expired. Send a template message to re-engage.",
    "windowClosedNoMessages": "Send a template message to start a conversation with this contact.",
    "messageFailed": "Message failed to send",
    "templateParamTitle": "Fill in Template Parameters",
    "templatePreview": "Preview",
    "templateParam": "Parameter {{index}}",
    "templateParamRequired": "All parameters are required",
    "sendTemplateBtn": "Send Template",
    "templateNoParams": "This template has no parameters.",
    "quickReplyPickerDesc": "Select a quick reply template...",
    "noQuickReplies": "No quick reply templates available.",
    "slashHint": "Quick replies",
    "slashNoMatches": "No matching quick replies",
    "slashClose": "Close quick replies",
    "revokedMessage": "This message was deleted",
    "revokedTooltip": "Deleted by contact",
    "edited": "edited",
    "editHistory": "Edit History",
    "editHistoryVersion": "Version {{index}}",
    "editHistoryCurrent": "Current",
    "download": "Download",
    "openInMaps": "Open in Maps",
    "contactCard": "Contact",
    "voiceMessage": "Voice Message",
    "stickerMessage": "Sticker",
    "document": "Document",
    "mediaLoadError": "Failed to load media",
    "locationMessage": "Location",
    "videoMessage": "Video",
    "imageMessage": "Image",
    "interactiveMessage": "Interactive Message",
    "templateMessage": "Template Message",
    "attachFile": "Attach file",
    "recordVoice": "Record voice message",
    "recording": "Recording...",
    "replyTo": "Reply",
    "replyingTo": "Replying to",
    "react": "React",
    "cancelAttachment": "Cancel",
    "caption": "Add a caption...",
    "uploadFailed": "Upload failed",
    "unsupportedFileType": "Unsupported file type",
    "fileTooLarge": "File too large (max {{max}}MB)",
    "sendingStatus": "Sending...",
    "removeReaction": "Remove reaction",
    "stopRecording": "Stop and send",
    "cancelRecording": "Cancel recording"
  },
  "settings": {
    "title": "Settings",
    "membersTab": "Members",
    "integrationsTab": "Integrations",
    "teamMembers": "Team Members",
    "teamMembersDesc": "Manage who has access to this WhatsApp Profile",
    "inviteMember": "Invite Member",
    "inviteTitle": "Invite Team Member",
    "emailAddress": "Email Address",
    "sendInvite": "Send Invite",
    "inviteSent": "Invitation sent to {{email}}",
    "easyCartTitle": "EasyCart Integration",
    "easyCartDesc": "Connect your EasyCart store for zero-sync order lookup",
    "easyCartApiUrl": "EasyCart API URL",
    "apiToken": "API Token",
    "saveIntegration": "Save Integration",
    "savedSuccess": "Saved successfully!",
    "whatsappProfileTitle": "WhatsApp Profile Info",
    "whatsappProfileDesc": "Profile details and phone number information will appear here once connected. Manage your WhatsApp Business Account settings through the Meta Business Suite."
  },
  "members": {
    "title": "User Management",
    "inviteMember": "Invite Member",
    "teamMembers": "Team Members",
    "teamMembersDesc": "Manage who has access to this WhatsApp Profile",
    "pendingInvitations": "Pending Invitations",
    "invitedBy": "Invited by",
    "inviteTitle": "Invite Team Member",
    "emailAddress": "Email Address",
    "role": "Role",
    "roleOwner": "Owner",
    "roleAdmin": "Admin",
    "roleAgent": "Agent",
    "roleReadOnly": "Read-Only",
    "sendInvite": "Send Invite",
    "sending": "Sending...",
    "inviteSent": "Invitation sent to {{email}}.",
    "inviteSentNewUser": "Account created and invitation sent to {{email}}.",
    "removeMember": "Remove Member",
    "removeConfirm": "Are you sure you want to remove {{name}} from this account? They will lose access immediately.",
    "memberRemoved": "Member removed.",
    "transferOwnership": "Transfer Ownership",
    "transferConfirm": "Are you sure you want to transfer ownership to {{name}}? You will be changed to Admin role.",
    "ownershipTransferred": "Ownership transferred.",
    "cancelInvitation": "Cancel Invitation",
    "invitationCancelled": "Invitation cancelled.",
    "resendInvitation": "Resend Invitation",
    "invitationResent": "Invitation resent.",
    "changeRole": "Change Role",
    "roleChanged": "Role updated.",
    "cannotRemoveOwner": "Cannot remove the Owner.",
    "cannotRemoveSelf": "You cannot remove yourself.",
    "operationFailed": "Operation failed. Please try again.",
    "nickname": "Nickname",
    "editNickname": "Edit nickname",
    "nicknameSaved": "Nickname updated",
    "nicknamePlaceholder": "Optional"
  },
  "invitation": {
    "title": "Team Invitation",
    "accept": "Accept Invitation",
    "decline": "Decline",
    "expired": "This invitation has expired.",
    "alreadyAccepted": "This invitation has already been accepted.",
    "notFound": "Invitation not found.",
    "youveBeenInvited": "You've been invited to join a team on LetChat.",
    "invitedBy": "Invited by",
    "asRole": "Role",
    "account": "Account",
    "acceptSuccess": "Invitation accepted! Redirecting...",
    "goToDashboard": "Go to Dashboard"
  },
  "tenantSelection": {
    "title": "Select Your WhatsApp Account",
    "subtitle": "Choose a curated workspace to begin your WhatsApp editorial session.",
    "accessAccount": "Access Account",
    "connectNew": "Connect New WhatsApp Account",
    "connectNewDesc": "Expand your editorial reach with a new curated WhatsApp profile.",
    "switchAccount": "Switch Account",
    "wabaNotLinked": "WABA NOT LINKED",
    "noQuotaTooltip": "No available quota. Please increase your creation quota before connecting a new account.",
    "copyright": "\u00a9 2024 LetChat CRM. All rights reserved.",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "support": "Support"
  },
  "whatsappSignup": {
    "dialogTitle": "Connect New WhatsApp Account",
    "dialogDescription": "Link your WhatsApp Business Account through Meta's secure Embedded Signup. You'll be guided through the setup in a popup window.",
    "stepLoadingSdk": "Loading Meta SDK...",
    "stepWaitingMeta": "Complete the setup in the Meta popup window...",
    "stepCollecting": "Syncing account data with Meta...",
    "stepExchanging": "Creating your WhatsApp profile...",
    "successTitle": "WhatsApp Account Connected!",
    "successDescription": "Your WhatsApp profile \"{{name}}\" has been created successfully. You'll be redirected to the dashboard shortly.",
    "errorTitle": "Connection Failed",
    "close": "Close",
    "goToDashboard": "Go to Dashboard"
  },
  "aiFaq": {
    "title": "AI FAQ Configuration",
    "description": "Upload FAQ documents to train the AI assistant. The system uses RAG (Retrieval-Augmented Generation) to answer customer questions based on your uploaded content.",
    "notEnabled": "AI FAQ is not enabled for this WhatsApp Profile. Contact your administrator to enable this add-on feature.",
    "knowledgeBase": "Knowledge Base",
    "knowledgeBaseDesc": "Upload PDF or TXT files to build the AI's knowledge base",
    "dragDrop": "Drag & drop files here, or click to browse",
    "supportedFormats": "Supported formats: PDF, TXT (max 10MB per file)",
    "browseFiles": "Browse Files",
    "generatingEmbeddings": "Generating embeddings...",
    "indexed": "Indexed ({{chunks}} chunks)",
    "testSandbox": "Test Sandbox",
    "testSandboxDesc": "Test AI responses with sample questions to verify quality",
    "askPlaceholder": "Ask a test question...",
    "ask": "Ask",
    "viewContexts": "View retrieved contexts ({{count}} chunks)",
    "chunk": "Chunk {{index}}",
    "score": "Score: {{score}}"
  },
  "templates": {
    "title": "Message Templates",
    "createTemplate": "Create Template",
    "searchPlaceholder": "Search templates...",
    "name": "Template Name",
    "category": "Category",
    "language": "Language",
    "status": "Status",
    "qualityScore": "Quality",
    "actions": "Actions",
    "viewDetails": "View details",
    "deleteTemplate": "Delete Template",
    "deleteConfirm": "Are you sure you want to delete template <strong>{{name}}</strong>? This action cannot be undone.",
    "editTemplate": "Edit Template",
    "editTitle": "Edit Message Template",
    "templateCreated": "Template submitted for review.",
    "templateUpdated": "Template updated and resubmitted for review.",
    "templateDeleted": "Template deleted.",
    "operationFailed": "Operation failed. Please try again.",
    "deleteFailed": "Failed to delete template.",
    "noTemplates": "No templates found. Create your first template to get started.",
    "statusAll": "All",
    "statusApproved": "Approved",
    "statusPending": "Pending",
    "statusRejected": "Rejected",
    "statusPaused": "Paused",
    "statusDisabled": "Disabled",
    "categoryMarketing": "Marketing",
    "categoryUtility": "Utility",
    "categoryAuthentication": "Authentication",
    "createTitle": "Create Message Template",
    "basicInfo": "Basic Info",
    "templateNameHelp": "Lowercase letters, numbers, and underscores only",
    "systemBadge": "System",
    "systemPrefixReserved": "The \"system_\" prefix is reserved for system templates. Please use a different name.",
    "content": "Content",
    "variableType": "Variable Type",
    "variableTypeName": "Name",
    "variableTypeNumber": "Number",
    "variableTypeHelp": "Variables are placeholders for dynamically inserting specific information. You can insert names or numbers as parameters.",
    "variableTypeNameExample": "Example: {{order_id}}, {{customer_name}}",
    "variableTypeNumberExample": "Example: {{1}}, {{2}}",
    "mediaSample": "Media Sample",
    "mediaNone": "None",
    "mediaImage": "Image",
    "mediaVideo": "Video",
    "mediaDocument": "Document",
    "header": "Header",
    "headerHelp": "Optional. Add a short title for your message.",
    "body": "Body",
    "bodyRequired": "Body text is required",
    "footer": "Footer",
    "footerHelp": "Optional. Add a short line of text at the bottom of your message.",
    "addVariable": "Add Variable",
    "variableNamePrompt": "Enter variable name (lowercase letters, underscores, and numbers):",
    "buttons": "Buttons",
    "buttonsHelp": "Create buttons for customers to reply or take action. Up to 10 buttons. If more than 3 buttons, they appear as a list.",
    "addButton": "Add Button",
    "buttonCustom": "Custom",
    "buttonVisitWebsite": "Visit Website",
    "buttonCallPhone": "Call Phone Number",
    "buttonText": "Button Text",
    "urlType": "URL Type",
    "urlTypeStatic": "Static",
    "urlTypeDynamic": "Dynamic",
    "websiteUrl": "Website URL",
    "countryRegion": "Country / Region",
    "phoneNumber": "Phone Number",
    "callToAction": "Call to Action",
    "quickReply": "Quick Reply",
    "duplicateButtonText": "Button text must be unique across Visit Website buttons.",
    "phoneRequired": "Please enter a valid phone number.",
    "messageValidity": "Message Validity",
    "messageValidityHelp": "Customize the validity period for utility messages. If not set, WhatsApp's standard 10-minute TTL applies.",
    "customValidity": "Custom message validity",
    "validitySeconds": "Validity (seconds)",
    "submit": "Submit Template",
    "submitting": "Submitting...",
    "uploadFile": "Upload File",
    "uploadDragDrop": "Drag & drop a file here, or click to browse",
    "uploading": "Uploading...",
    "uploadFailed": "File upload failed.",
    "exampleValues": "Example Values",
    "exampleValuesHelp": "Provide example values for each variable. These are reviewed as part of template approval.",
    "errorNamedFormat": "This template contains incorrectly formatted variable parameters. Variable parameters must consist of lowercase letters, underscores, and numbers, wrapped in double curly braces (e.g. {{customer_name}}, {{order_id}}). Variables must not be at the start or end of the template.",
    "errorPositionalFormat": "This template contains incorrectly formatted variable parameters. Variable parameters must be integers wrapped in curly braces (e.g. {{1}}, {{2}}). Variables must not be at the start or end of the template.",
    "errorTooManyVariables": "This template has too many variables relative to the message length. Please reduce the number of variables or increase the message length.",
    "errorVariableStartEnd": "Variables must not be at the start or end of the template.",
    "errorNamedDuplicate": "Duplicate variable names are not allowed.",
    "errorPositionalSequence": "Positional variables must be sequential (e.g. {{1}}, {{2}}, {{3}}).",
    "errorHeaderEmoji": "Header text cannot contain emojis. WhatsApp will reject the template.",
    "errorFooterEmoji": "Footer text cannot contain emojis. WhatsApp will reject the template.",
    "maxButtons": "Maximum {{max}} buttons of this type allowed."
  },
  "quickReply": {
    "title": "Quick Reply Templates",
    "createTemplate": "Create Template",
    "createTitle": "Create Quick Reply Template",
    "editTitle": "Edit Quick Reply Template",
    "searchPlaceholder": "Search quick replies...",
    "name": "Template Name",
    "nameHelp": "A descriptive name for this quick reply",
    "command": "Command",
    "commandHelp": "Lowercase letters, digits, - and _. Type / then this in a chat to pick this reply.",
    "commandInvalid": "Use lowercase letters, digits, - and _ only.",
    "messageType": "Message Type",
    "typeText": "Plain Text",
    "typeInteractive": "Interactive",
    "interactiveType": "Interactive Type",
    "replyButtons": "Reply Buttons",
    "listMessage": "List Message",
    "headerSection": "Header",
    "header": "Header Text",
    "headerHelp": "Optional. A short title shown at the top of the message (max 60 chars).",
    "body": "Body",
    "footer": "Footer",
    "footerHelp": "Optional. A short line of text at the bottom of the message (max 60 chars).",
    "mediaType": "Header Media Type",
    "mediaTypeNone": "None (text only)",
    "mediaTypeImage": "Image",
    "mediaTypeVideo": "Video",
    "mediaTypeDocument": "Document",
    "mediaTypeHelp": "Select a media type for the header, or leave as none for text header.",
    "uploadDragDrop": "Drag & drop a file here, or click to browse",
    "uploadFailed": "File upload failed. Please try again.",
    "mediaUploaded": "Media uploaded",
    "buttonTitle": "Button label",
    "addButton": "Add Button",
    "maxButtons": "Maximum 3 reply buttons allowed.",
    "listButtonText": "Menu Button Label",
    "listButtonTextHelp": "The label for the button that opens the list menu (max 20 chars).",
    "sections": "Sections",
    "addSection": "Add Section",
    "sectionTitle": "Section Title",
    "rows": "Rows",
    "addRow": "Add Row",
    "rowTitle": "Row title",
    "rowDescription": "Description (optional)",
    "previewTitle": "Preview Interactive Message",
    "confirmSend": "Send",
    "listSectionsPreview": "List sections:",
    "created": "Created",
    "viewDetails": "View details",
    "deleteTemplate": "Delete Template",
    "deleteConfirm": "Are you sure you want to delete <strong>{{name}}</strong>? This action cannot be undone.",
    "templateCreated": "Quick reply template created.",
    "templateUpdated": "Quick reply template updated.",
    "templateDeleted": "Quick reply template deleted.",
    "operationFailed": "Operation failed. Please try again.",
    "noTemplates": "No quick reply templates found. Create your first template to get started.",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "bulkDelete": "Delete Selected",
    "bulkDeleteConfirm": "Are you sure you want to delete {{count}} quick reply templates? This action cannot be undone.",
    "bulkDeleteSuccess": "{{count}} quick reply templates deleted.",
    "sourceSystem": "System",
    "sourceCustom": "Custom",
    "sourceLabel": "Source",
    "systemReadOnly": "System templates are managed by LetChat and cannot be edited or deleted.",
    "systemTooltip": "Managed by LetChat",
    "typeEshop": "EasyCart Function",
    "typeEshopDisabled": "Connect EasyCart in Integrations to enable this option."
  },
  "autoReply": {
    "title": "Auto Reply",
    "description": "Set up keyword-triggered auto-replies to create an IVR-like system. When a customer sends a message matching your keywords, the system automatically responds.",
    "createRule": "Create Auto Reply",
    "editRule": "Edit Auto Reply",
    "searchPlaceholder": "Search auto replies...",
    "keywords": "Trigger Keywords",
    "keywordsHelp": "Add keywords that trigger this auto-reply. Button titles from other templates are suggested. Press Enter to add.",
    "keywordsPlaceholder": "Type a keyword and press Enter...",
    "fromButton": "Button",
    "matchType": "Match Type",
    "matchContains": "Contains",
    "matchExact": "Exact Match",
    "matchContainsHelp": "Reply is sent when the keyword appears anywhere in the customer's message.",
    "matchExactHelp": "Reply is sent only when the customer's message matches the keyword exactly.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "status": "Status",
    "nextStep": "Next Step",
    "nextStepHelp": "Select an auto-reply template to send when this button is clicked.",
    "nextStepNone": "None (end of flow)",
    "nextStepCreate": "Create new template...",
    "noRules": "No auto-reply rules found. Create your first rule to get started.",
    "ruleCreated": "Auto-reply rule created.",
    "ruleUpdated": "Auto-reply rule updated.",
    "ruleDeleted": "Auto-reply rule deleted.",
    "deleteRule": "Delete Auto Reply",
    "deleteConfirm": "Are you sure you want to delete <strong>{{name}}</strong>? Any chained rules that link to this template will lose their connection.",
    "operationFailed": "Operation failed. Please try again.",
    "viewList": "List View",
    "viewFlow": "Flow Canvas",
    "addTrigger": "Add Trigger",
    "autoLayout": "Auto Layout",
    "fitView": "Fit View",
    "triggerNode": "Trigger",
    "messageNode": "Message",
    "paused": "Paused",
    "flowSaved": "Flow saved.",
    "flowSaveFailed": "Failed to save flow.",
    "bulkDeleteConfirm": "Are you sure you want to delete {{count}} auto-reply rules? This action cannot be undone.",
    "bulkDeleteSuccess": "{{count}} auto-reply rules deleted.",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "deleteHasChildren": "\"{{name}}\" has linked sub-nodes. Choose how to handle them:",
    "affectedChildren": "Affected sub-nodes:",
    "deleteThisOnly": "Delete this node only",
    "deleteThisOnlyDesc": "Sub-nodes will keep their keywords and become independent entry points.",
    "deleteSubtree": "Delete entire subtree",
    "deleteSubtreeDesc": "Delete this node and all {{count}} linked sub-nodes.",
    "subtreeDeleted": "{{count}} auto-reply rules deleted.",
    "duplicateKeywords": "Duplicate keywords found: {{conflicts}}. Each keyword can only belong to one auto-reply rule.",
    "eshopFunction": "EasyCart Function",
    "eshopFunctionHelp": "Pick the EasyCart action this template should run after the Q&A.",
    "eshopFunctionSelect": "Function",
    "eshopNoIntegration": "This template uses an EasyCart function but EasyCart is not connected. Connect it in Integrations or the flow will not run.",
    "eshopOpeningMessage": "Opening message",
    "eshopOpeningMessageHelp": "Sent to the contact before the first question.",
    "eshopParamQuestion": "Question to ask",
    "eshopParamRegexReadonly": "Expected answer format",
    "eshopParamRegexReadonlyHelp": "Defined by the EasyCart function. Admins can't change it — the function will fail if the answer doesn't match.",
    "eshopParamError": "Error message (optional)",
    "eshopParamErrorHelp": "Shown when the answer doesn't match the regex. The question is then re-asked.",
    "eshopCancelButtonLabel": "Cancel button label",
    "eshopCancelButtonLabelHelp": "Shown on the Cancel button next to each question (max 20 chars). Defaults to \"Cancel\"."
  },
  "integration": {
    "settingsTitle": "Integrations",
    "connected": "Connected",
    "disconnected": "Not Connected",
    "merchantId": "Merchant ID",
    "storeName": "Store Name",
    "connectedSince": "Connected since",
    "permissions": "Permissions",
    "disconnect": "Disconnect",
    "disconnectTitle": "Disconnect EasyCart",
    "disconnectConfirm": "Are you sure you want to disconnect this EasyCart integration? You will lose access to the linked store data.",
    "noIntegration": "No integration connected. Use the sidebar button to connect your EasyCart store.",
    "connecting": "Connecting...",
    "connectSuccess": "EasyCart connected successfully!",
    "connectFailed": "Failed to connect EasyCart.",
    "noProfile": "No EasyCart merchant account found for this user. Please create an EasyCart account first.",
    "denied": "Authorization was denied.",
    "error": "An error occurred during authorization."
  },
  "integrations": {
    "eshop": {
      "records": "EasyCart Records",
      "customerInfo": "Customer Info",
      "orders": "Orders",
      "bookings": "Bookings",
      "notFound": "No records found",
      "notConnected": "EasyCart not connected",
      "fetchError": "Failed to fetch EasyCart data",
      "orderDetail": "Order Detail",
      "customerData": "Customer Info",
      "shippingInfo": "Shipping Info",
      "orderItems": "Order Items",
      "orderRemarks": "Order Remarks",
      "noRemarks": "No remarks",
      "productAmount": "Product Amount",
      "transactionFee": "Transaction Fee",
      "notApplicable": "N/A",
      "field": {
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "membership": "Membership",
        "points": "Points",
        "memberSince": "Member since",
        "orderNumber": "Order #",
        "amount": "Amount",
        "status": "Status",
        "paymentMethod": "Payment Method",
        "date": "Date",
        "service": "Service",
        "dateTime": "Date & Time",
        "price": "Price",
        "confirmed": "Confirmed",
        "paid": "Paid",
        "customer": "Customer",
        "recipient": "Recipient",
        "contactPhone": "Phone",
        "contactEmail": "Email",
        "shippingMethod": "Shipping Method",
        "shippingNumber": "Tracking #",
        "shippingFee": "Shipping Fee Charged",
        "deliveryAddress": "Delivery Address",
        "orderDate": "Order Date",
        "product": "Product",
        "quantity": "Qty",
        "unitPrice": "Unit Price",
        "subtotal": "Subtotal",
        "discount": "Discount",
        "total": "Total",
        "freeShipping": "Free Shipping",
        "notShippedYet": "Not shipped yet"
      },
      "orderStatus": {
        "processing": "Paid",
        "shipped": "Shipped",
        "completed": "Completed",
        "failure": "Failed"
      },
      "paymentMethod": {
        "in-app": "In-app Payment",
        "wechat-pay": "WeChat Pay",
        "alipay": "Alipay",
        "alipayhk": "AlipayHK",
        "paypal": "PayPal",
        "card": "Credit Card",
        "bbmsl": "BBMSL",
        "bank": "Bank Transfer",
        "qfpay": "QFPay",
        "CASH_PAY": "Cash",
        "CREDIT_CARD_PAY": "Credit Card",
        "ALI_PAY": "Alipay",
        "WECHAT_PAY": "WeChat Pay",
        "OCTOPUS_PAY": "Octopus",
        "VISA_PAY": "Visa",
        "MASTER_CARD_PAY": "Mastercard",
        "FPS_PAY": "FPS",
        "PAYME_PAY": "PayMe"
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "clearAll": "Clear all",
    "noNotifications": "No notifications",
    "markAllRead": "Mark all read",
    "importComplete": "Contact Import Complete",
    "importCompleteMsg": "Created {{created}}, updated {{updated}}, skipped {{skipped}}.",
    "importResultTitle": "Import Result",
    "importResultCreated": "Created: {{count}} contacts",
    "importResultUpdated": "Updated: {{count}} contacts",
    "importResultSkipped": "Skipped: {{count}} rows",
    "importResultErrorsTitle": "Errors",
    "importResultErrorRow": "Row {{row}}:",
    "importFailed": "Contact Import Failed",
    "failedMsg": "An error occurred. Please contact support.",
    "templateApproved": "Template Approved",
    "templateApprovedMsg": "Template \"{{templateName}}\" ({{language}}) has been approved and is ready to use.",
    "templateRejected": "Template Rejected",
    "templateRejectedMsg": "Template \"{{templateName}}\" ({{language}}) was rejected. Reason: {{reason}}",
    "templateStatusChanged": "Template Status Changed",
    "templateStatusChangedMsg": "Template \"{{templateName}}\" ({{language}}) status changed to {{status}}.",
    "templateCategoryWarning": "Template Recategorization Pending",
    "templateCategoryWarningMsg": "Template \"{{templateName}}\" ({{language}}) will be recategorized from {{newCategory}} to {{correctCategory}} within 24 hours.",
    "templateCategoryUpdated": "Template Category Changed",
    "templateCategoryUpdatedMsg": "Template \"{{templateName}}\" ({{language}}) category changed from {{previousCategory}} to {{newCategory}}.",
    "contactAssigned": "Assigned to a contact",
    "contactAssignedMsg": "{{actorName}} assigned you to {{contactName}}.",
    "timeAgo": {
      "justNow": "Just now",
      "minutesAgo": "{{count}}m ago",
      "hoursAgo": "{{count}}h ago",
      "daysAgo": "{{count}}d ago"
    }
  },
  "mobilePairing": {
    "menuEntry": "Mobile devices",
    "title": "Pair a mobile device",
    "subtitle": "Generate a QR code and scan it with the LetChat mobile app to sign in.",
    "prompt": "Generate a fresh QR code to pair a device.",
    "generate": "Generate QR code",
    "scanInstructions": "Open the LetChat mobile app and scan this code. It expires in 5 minutes and can only be used once.",
    "paired": "Paired successfully",
    "expired": "Code expired — generate a new one.",
    "cancel": "Cancel",
    "pairedDevices": "Paired devices",
    "noDevices": "No devices paired yet.",
    "revoke": "Revoke",
    "revoked": "Revoked",
    "manualFallback": "If the scan doesn't work, enter this pairing code on your phone:",
    "copy": "Copy",
    "copied": "Copied",
    "lastUsedAt": "last active",
    "pairedAt": "paired",
    "unknownPlatform": "Unknown device"
  },
  "apiClients": {
    "menuEntry": "API clients",
    "title": "API clients",
    "subtitle": "OAuth credentials for third-party integrations (Zapier, n8n, your own backend).",
    "lede": "Issue API credentials for Zapier, n8n, or your own backend to access LetChat data on your behalf. Each client uses short-lived access tokens (30 min) — exchanged from a long-lived Client Secret.",
    "developerBadge": "Developer · API platform",
    "createButton": "New client",
    "searchPlaceholder": "Search by name or description…",
    "showRevoked": "Show revoked",
    "noMatches": "No clients match \"{{term}}\".",
    "revoked": "Revoked",
    "revoke": "Revoke",
    "created": "Created",
    "lastUsed": "Last used",
    "ipRestricted": "IP allowlist",
    "anyIp": "Any IP",
    "activeUsed": "active · used {{ago}}",
    "workspacesPlural": "{{count}} workspaces",
    "scopesPlural_one": "{{count}} scope",
    "scopesPlural_other": "{{count}} scopes",
    "ipAllowlistCount_one": "{{count}} IP allowlist",
    "ipAllowlistCount_other": "{{count}} IP allowlist",
    "stats": {
      "activeClients": "Active clients",
      "ipRestricted": "IP-restricted clients",
      "calls7d": "API calls — last 7 days",
      "rateLimit": "Rate limit",
      "perClient": "per client",
      "comingSoon": "coming soon"
    },
    "empty": {
      "archivalLabel": "§I · Setup",
      "title": "Connect your stack to LetChat",
      "body": "Create an API client to let Zapier, n8n, or your own backend read contacts, send messages, and manage templates on your behalf. Each client uses short-lived 30-minute access tokens exchanged from a long-lived Client Secret.",
      "createFirst": "Create your first client",
      "benefits": {
        "scoped": {
          "title": "Workspace-scoped",
          "body": "Pick which workspaces and which features each client can touch — separate from your user permissions, but enforced on every request."
        },
        "shortLived": {
          "title": "Short-lived tokens",
          "body": "Tokens expire automatically after 30 minutes, and revocations take effect immediately."
        },
        "audit": {
          "title": "Audit-logged",
          "body": "All API requests are recorded in the audit log for 7 days."
        }
      }
    },
    "scopeGroups": {
      "contacts": { "label": "Contacts", "description": "Customer records, tags, notes" },
      "messages": { "label": "Messages", "description": "Inbound / outbound message stream" },
      "remarks": { "label": "Remarks", "description": "Internal notes attached to a contact" },
      "templates": { "label": "Templates", "description": "WhatsApp message templates" },
      "quickReplies": { "label": "Quick replies", "description": "Agent shortcut snippets" },
      "autoReplies": { "label": "Auto-replies", "description": "Rule-based automation" },
      "aiFaq": { "label": "AI FAQ", "description": "Knowledge base + AI answers" },
      "members": { "label": "Members", "description": "Workspace seat management" },
      "settings": { "label": "Settings", "description": "Workspace settings" },
      "tags": { "label": "Contact tags", "description": "Manage and apply contact tags" }
    },
    "scopeLabels": {
      "read": "Read",
      "write": "Create / Update",
      "delete": "Delete",
      "assign": "Assign",
      "send": "Send",
      "apply": "Apply"
    },
    "create": {
      "title": "Create API client",
      "newClient": "New client",
      "issueCredentials": "Issue credentials",
      "shortLivedNotice": "Access tokens expire after 30 minutes.",
      "stepCounter": "Step {{current}} of {{total}}",
      "back": "Back",
      "continue": "Continue",
      "issue": "Issue credentials",
      "creating": "Creating…",
      "genericError": "Could not create the client. Please try again.",
      "nameLabel": "Client name",
      "namePlaceholder": "e.g. Zapier — production",
      "nameHelper": "{{count}}/60 characters · shown in audit logs and the client list",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "What this client does, who maintains it, and where it runs.",
      "namingTipTitle": "Naming tip",
      "namingTipBody": "Prefix with the tool and environment — n8n — staging, Internal BI.",
      "noTenants": "You don't have access to any workspaces yet.",
      "noCurrentWorkspace": "Select a workspace first.",
      "noScopesAvailable": "Your role doesn't grant any API scopes in this workspace. Ask an admin to upgrade your role, or have them issue the client on your behalf.",
      "tenantRoleLine": "{{permissions}} permissions",
      "selectTenantsFirst": "Select at least one workspace first.",
      "scopesIntro": "Showing scopes your role can grant in the current workspace.",
      "scopesIntro_one": "Showing scopes valid in the {{count}} selected workspace.",
      "scopesIntro_other": "Showing scopes valid across all {{count}} selected workspaces.",
      "selectAllAvailable": "Select all available",
      "scopeLockedHint": "Your role doesn't grant this permission in every selected workspace",
      "ipModeAny": {
        "title": "Any IP",
        "body": "Allow requests from any source. Use if your integration runs on Zapier / serverless infra with dynamic IPs."
      },
      "ipModeAllowlist": {
        "title": "IP allowlist",
        "body": "Only requests from listed addresses are accepted. Recommended for self-hosted backends."
      },
      "recommended": "Recommended",
      "ipAllowlistLabel": "Allowed IPs / CIDR ranges",
      "ipAllowlistHelper": "One per line. IPv4, IPv6, or CIDR notation.",
      "ipRejectNotice": "Requests from any IP outside this list will be rejected.",
      "alwaysOnTitle": "Always-on protections",
      "alwaysOnBody": "The platform enforces a 120 requests / minute rate limit and records every request in the audit log for 7 days.",
      "steps": {
        "details": { "label": "Details", "title": "Name your client", "blurb": "Give this client a clear, internal name. Only you will see this." },
        "access": { "label": "Workspaces", "title": "Pick workspaces", "blurb": "Select which workspaces this client can act in. We'll re-check your permissions on every request." },
        "scopes": { "label": "Permissions", "title": "Choose permissions", "blurb": "Pick the smallest set of scopes the integration needs. Only scopes you can grant in every selected workspace are shown." },
        "restrict": { "label": "Restrictions", "title": "Restrict access", "blurb": "Optionally limit which IP addresses can use this client. We'll reject requests from any other source." },
        "review": { "label": "Review", "title": "Review & issue", "blurb": "Last check before we issue the Client ID and Client Secret. The secret is shown only once." }
      }
    },
    "review": {
      "name": "Name",
      "description": "Description",
      "workspace": "Workspace",
      "workspaces": "Workspaces",
      "scopes": "Scopes",
      "scopesWithCount": "Scopes · {{count}}",
      "ipRestriction": "IP restriction",
      "anyIp": "Any IP allowed",
      "secretWarning": "The Client Secret will be shown once on the next screen. Copy it into your password manager — we cannot show it again."
    },
    "secretDialog": {
      "badge": "Credentials issued — shown once",
      "title": "Save your Client Secret now",
      "subtitle": "Once you close this dialog, we cannot show this secret again — you would have to rotate it.",
      "clientIdLabel": "Client ID",
      "clientSecretLabel": "Client Secret",
      "quickstart": "Quickstart",
      "acknowledge": "I have saved the Client Secret somewhere safe",
      "done": "Done"
    },
    "detail": {
      "activeClient": "Active client",
      "tabs": {
        "overview": "Overview",
        "code": "Quickstart",
        "settings": "Settings"
      },
      "clientIdLabel": "Client ID",
      "clientSecretLabel": "Client Secret",
      "hashedAtRest": "stored securely",
      "miniStats": {
        "calls7d": "Calls · 7d",
        "errorRate": "Error rate",
        "lastUsed": "Last used"
      },
      "never": "Never",
      "sections": {
        "workspaces": "Workspaces",
        "scopes": "Scopes",
        "ipAllowlist": "IP allowlist"
      },
      "granted_one": "{{count}} granted",
      "granted_other": "{{count}} granted",
      "ranges_one": "{{count}} range",
      "ranges_other": "{{count}} ranges",
      "unrestricted": "Unrestricted",
      "anyIpWarning": "Any IP can use this client. For backends running on a fixed network, consider an allowlist.",
      "rateLimit": "120 requests / minute · tokens expire in 30 minutes",
      "quickstart": {
        "exchangeTitle": "Exchange the secret for an access token",
        "exchangeBody": "Re-exchange whenever the access token expires.",
        "callTitle": "Call the API with the access token",
        "callBody": "The workspace is bound to this client — no extra header is required.",
        "sendTitle": "Send a templated message",
        "sendBody": "Standard request — same shape as the in-app surface, just with a bearer token."
      },
      "activity": {
        "title": "Recent calls",
        "subtitle": "From the audit log · 7-day retention",
        "loading": "Loading audit log…",
        "loadingMore": "Loading more…",
        "loadMore": "Load more",
        "empty": "No API calls yet. Once this client makes a request, it will appear here.",
        "columns": {
          "time": "Time",
          "method": "Method",
          "path": "Path",
          "status": "Status",
          "latency": "Latency"
        }
      },
      "settings": {
        "editable": "Editable",
        "ipAllowlist": "IP allowlist",
        "anyIp": "Any IP",
        "restrict": "Restrict",
        "lockedFields": "Locked fields",
        "lockedHint": "To widen access, create a new client",
        "tenantsCount_one": "{{count}} workspace",
        "tenantsCount_other": "{{count}} workspaces",
        "scopesCount_one": "{{count}} scope",
        "scopesCount_other": "{{count}} scopes",
        "dangerZone": "Danger zone",
        "rotateTitle": "Rotate Client Secret",
        "rotateBody": "Generates a new secret. The old secret stops working immediately.",
        "rotate": "Rotate",
        "rotateComingSoon": "Coming soon",
        "revokeBody": "All active tokens stop working immediately. Cannot be undone.",
        "discard": "Discard",
        "save": "Save changes",
        "saving": "Saving…"
      }
    },
    "confirmRevoke": {
      "title": "Revoke this client?",
      "body": "All active access tokens for <strong>{{name}}</strong> will stop working immediately. Any running integration will lose access until a replacement is issued.",
      "typeToConfirm": "Type <strong>{{name}}</strong> to confirm",
      "cancel": "Cancel",
      "confirm": "Revoke client"
    },
    "confirmRotate": {
      "title": "Rotate Client Secret?",
      "body": "Generating a new secret for <strong>{{name}}</strong> will immediately invalidate all access tokens issued from the old secret. Any running integration must switch to the new secret to keep working.",
      "typeToConfirm": "Type <strong>{{name}}</strong> to confirm",
      "cancel": "Cancel",
      "confirm": "Rotate secret"
    }
  },
  "developer": {
    "badge": "Developer · API platform",
    "title": "Developer platform",
    "lede": "Issue API credentials and explore the documentation for this workspace's third-party API.",
    "tabs": {
      "clients": "Clients",
      "docs": "API docs"
    }
  },
  "apiDocs": {
    "errorTitle": "Could not load the API documentation",
    "errorBody": "Run `php artisan scribe:generate` on the backend to publish the OpenAPI spec, then refresh this page."
  },
  "tags": {
    "title": "Contact tags",
    "subtitle": "Workspace-wide vocabulary for organising contacts. Every member can apply tags; only owners and admins can rename, recolour, or delete them.",
    "adminBadge": "Admin · Workspace library",
    "create": "Create tag",
    "edit": "Edit tag",
    "delete": "Delete tag",
    "searchPlaceholder": "Search tags by name…",
    "noMatches": "No tags match \"{{term}}\"",
    "categoryCount_one": "{{count}} tag",
    "categoryCount_other": "{{count}} tags",
    "card": {
      "unused": "Unused",
      "contactsCount_one": "Contact",
      "contactsCount_other": "Contacts"
    },
    "empty": {
      "title": "Build a shared tag vocabulary",
      "body": "Tags let your team segment contacts the same way. Common starting points: customer tier (VIP, lead, closed), status (needs follow-up, urgent), region (HK, TW).",
      "cta": "Create first tag"
    },
    "stats": {
      "inLibrary": "Tags in library",
      "active": "Active tags",
      "unused": "{{count}} unused",
      "categories": "Categories"
    },
    "filters": {
      "label": "Filter by tags",
      "addAction": "Add tag filter",
      "addMore": "Add",
      "clearAction": "Clear",
      "intersectionHint": "Intersection of all tags",
      "allCategories": "All"
    },
    "picker": {
      "applyTitle": "Apply tags",
      "filterTitle": "Filter by tags",
      "applyBlurb": "Tags applied to {{name}} are visible to every workspace member.",
      "filterBlurb": "Results show contacts matching every selected tag (intersection).",
      "searchPlaceholder": "Search tags…",
      "noMatches": "No tags match \"{{term}}\"",
      "submitApply": "Save tags",
      "submitFilter": "Apply filter",
      "noneSelected": "No tags selected",
      "selectedCount_one": "{{count}} tag selected",
      "selectedCount_other": "{{count}} tags selected",
      "clearSelected_one": "Clear ({{count}})",
      "clearSelected_other": "Clear ({{count}})"
    },
    "editor": {
      "preview": "Preview",
      "namePlaceholder": "Tag name",
      "nameLabel": "Name",
      "nameHint": "{{n}}/64 characters",
      "colorLabel": "Color",
      "colorHint": "Used in lists and filter",
      "categoryLabel": "Category",
      "categoryHint": "Tags are grouped by category in the picker",
      "categoryNamePlaceholder": "Category name",
      "newCategory": "New category",
      "pickExisting": "Pick existing",
      "createBlurb": "Tags are visible to every member of the workspace.",
      "editBlurb_one": "Changes apply to the {{count}} contact using this tag.",
      "editBlurb_other": "Changes apply to all {{count}} contacts using this tag.",
      "editImpact_one": "Renaming or recoloring affects {{count}} existing contact immediately.",
      "editImpact_other": "Renaming or recoloring affects {{count}} existing contacts immediately.",
      "saveChanges": "Save changes"
    },
    "deleteDialog": {
      "title": "Delete this tag?",
      "impact_one": "will be removed from {{count}} contact. Their other tags are unaffected. This cannot be undone.",
      "impact_other": "will be removed from {{count}} contacts. Their other tags are unaffected. This cannot be undone.",
      "typePrompt": "Type"
    },
    "errors": {
      "saveFailed": "Could not save the tag. Please try again.",
      "deleteFailed": "Could not delete the tag. Please try again."
    },
    "contacts": {
      "columnHeader": "Tags",
      "noTags": "No tags",
      "addAction": "Add tags",
      "editAction": "Edit tags"
    }
  }
}
